import React from "react"
import { BrowserRouter, Route, Switch } from "react-router-dom"
import LandingPage from "../../pages/landing_page/LandingPage"
import AuthRoutes, { AuthRoutesList } from "./AuthRoutes"
import AdminRoutes, { AdminRoutesList } from "./AdminRoutes"
import CustomerRoutes, { CustomerRouteList } from "./CustomerRoutes"

const RouteList = [
  {
    path: AdminRoutesList.map(a => a.path),
    exact: true,
    component: AdminRoutes
  },
  {
    path: AuthRoutesList.map(a => a.path),
    exact: true,
    component: AuthRoutes
  },
  {
    path: CustomerRouteList.map(a => a.path),
    exact: true,
    component: CustomerRoutes
  },
  {
    path: "",
    exact: true,
    component: LandingPage
  }
]

const Routes = () => {
  return (
    <BrowserRouter>
      <Switch>
        {RouteList.map(r => (
          <Route
            key={r.path}
            path={r.path}
            component={r.component}
            exact={r.exact}
          />
        ))}
      </Switch>
    </BrowserRouter>
  )
}

export default Routes
